import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Camera } from 'lucide-react';
interface Props {
  onNext: () => void;
}
export const PostScreen4Requested = ({
  onNext
}: Props) => {
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-86">
      {/* Background Video */}
      <div className="absolute inset-0" data-id="element-87">
        <video src="https://cdn.magicpatterns.com/uploads/fQFTKhbTs1W58wgx5hcKuv/stand.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover opacity-80" data-id="element-88" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/20 via-slate-950/40 to-slate-950/90" data-id="element-89" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-90">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-4" data-id="element-91">
          03 — You Requested
        </motion.span>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center space-x-3 mb-6" data-id="element-92">
          <div className="w-12 h-12 bg-green-500/20 rounded-2xl flex items-center justify-center border border-green-500/30" data-id="element-93">
            <Camera className="w-6 h-6 text-green-500" data-id="element-94" />
          </div>
          <div data-id="element-95">
            <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-96">
              From your request
            </p>
            <p className="text-white font-semibold" data-id="element-97">
              "Show us behind the scenes"
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3
      }} className="bg-slate-900/80 border border-slate-800 rounded-3xl p-6 mb-6" data-id="element-98">
          <h3 className="text-white font-semibold text-lg mb-3" data-id="element-99">
            We captured it for you
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-4" data-id="element-100">
            From early morning setup to late-night team debriefs. The energy,
            the preparation, the spontaneous moments between sessions.
          </p>
          <div className="flex items-center space-x-2 text-xs text-green-400" data-id="element-101">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-102" />
            <span data-id="element-103">More footage coming soon</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="bg-slate-900/40 border border-slate-800 rounded-2xl p-4 mb-6" data-id="element-104">
          <p className="text-sm text-slate-400 italic" data-id="element-105">
            "The best part? Seeing our team in action. You can feel the
            passion."
          </p>
          <p className="text-xs text-slate-500 mt-2" data-id="element-106">— Attendee feedback</p>
        </motion.div>

        <div className="mt-auto" data-id="element-107">
          <button onClick={onNext} className="w-full bg-green-600 hover:bg-green-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-108">
            <span data-id="element-109">Continue</span>
            <ArrowRight className="w-5 h-5" data-id="element-110" />
          </button>
        </div>
      </div>
    </div>;
};